import { render, staticRenderFns } from "./PreRegSubjectsShow.vue?vue&type=template&id=926b5362&scoped=true"
import script from "./PreRegSubjectsShow.vue?vue&type=script&lang=js"
export * from "./PreRegSubjectsShow.vue?vue&type=script&lang=js"
import style0 from "./PreRegSubjectsShow.vue?vue&type=style&index=0&id=926b5362&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "926b5362",
  null
  
)

export default component.exports